import { useMemo } from 'react';

/**
 * Shared hook for filtering media into slot-based categories (headshots, aboutPhotos, galleryPhotos, videos).
 * Used by BoldTemplate, CleanTemplate, CreativeTemplate, and PopTemplate.
 */
export default function useMediaFiltering(media) {
  const headshots = useMemo(
    () => (media ? media.filter((m) => m.media_type === 'image' && m.slot === 'headshot') : []),
    [media]
  );

  const aboutPhotos = useMemo(
    () => (media ? media.filter((m) => m.media_type === 'image' && m.slot === 'about') : []),
    [media]
  );

  const galleryPhotos = useMemo(
    () =>
      media
        ? media
            .filter((m) => m.media_type === 'image' && m.slot === 'gallery')
            .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0))
        : [],
    [media]
  );

  const videos = useMemo(
    () => (media ? media.filter((m) => m.media_type === 'video') : []),
    [media]
  );

  return { headshots, aboutPhotos, galleryPhotos, videos };
}
